module.exports = __webpack_public_path__ + "img/agreement.8120fa2a.svg";